export default {
  phone: [
    {
      message: "请输入手机号",
      required: true,
    },
    {
      message: "手机号格式不正确",
      pattern: /^(?:(?:\+|00)86)?1\d{10}$/,
    },
  ],
  workCmpy: [
    {
      message: "请输入工作单位",
      required: true,
    },
    {
      message: "工作单位最多100字",
      max: 100,
    },
  ],
  skillLevel: [
    {
      message: "请输入技能级别",
      required: true,
    },
    {
      message: "技能级别最多100字",
      max: 100,
    },
  ],
  skillCertCode: [
    {
      message: "请输入职业证书编号",
      required: true,
    },
    {
      message: "职业证书编号最多100字",
      max: 100,
    },
  ],
  skillCertName: [
    {
      message: "请输入职业证书名称",
      required: true,
    },
    {
      message: "职业证书名称最多100字",
      max: 100,
    },
  ],
}